import { Live2Action } from "./live-2-types";
import { Thunk } from "../../common";
import { SnackBarAction } from "../../snackbar/snackbar-types";
import gql from "../../gqlTag";
import { callGqlApi } from "../../../helpers/api";
import { handleGqlErrors } from "../../gql-error/gql-error-actions";
import { basicSnackbar, customSnackbar, removeSnackbar } from "../../snackbar/snackbar-actions";
import { listWorkspaces } from "../../workspace/workspace-actions";

export function getLiveCompanies(): Thunk<void, Live2Action> {
  const q = gql`
    query {
      liveCompanies {
        id
        sites {
          name
          mappedStudy {
            id
            name
          }
        }
        mappedWorkspace {
          id
          name
          creator {
            email
          }
        }
      }
    }
  `;
  return dispatch => {
    callGqlApi(q)
      .then(data => {
        dispatch({ type: "SET_COMPANIES", payload: { companies: data.liveCompanies } });
      })
      .catch(e => dispatch(handleGqlErrors(e)));
  };
}

export function importLiveCompany(
  companyId: string
): Thunk<Promise<any>, Live2Action | SnackBarAction> {
  return async (dispatch, getState) => {
    const key = `live-import-${new Date().valueOf()}`;
    dispatch(customSnackbar("progress", { message: `Importing ${companyId}` }, key));
    const mut = gql`
      mutation mut($input: ImportLiveCompanyInput!) {
        importLiveCompany(input: $input) {
          numAnimalsImported
          company {
            mappedWorkspace {
              id
            }
          }
        }
      }
    `;

    try {
      const res = await callGqlApi(mut, {
        input: {
          companyId,
        },
      });
      const { mappedWorkspace } = res.importLiveCompany.company;
      if (!getState().workspaces.workspaces.find(w => w.id === mappedWorkspace.id)) {
        dispatch(listWorkspaces());
      }
      dispatch(
        basicSnackbar(
          `Imported selected sites, animals imported: ${res.importLiveCompany.numAnimalsImported}`,
          "success"
        )
      );
      dispatch(removeSnackbar(key));
      dispatch(getLiveCompanies());
      return res;
    } catch (e) {
      dispatch(removeSnackbar(key));
      dispatch(handleGqlErrors(e));
    }
  };
}
